<div class="secureLogo">
  <fa-icon icon="lock"></fa-icon>
  <span>Paga seguro con</span> <img
  src="assets/images/payvalida.svg"
  alt="Payvalida, pasarela de pagos"
  title="Payvalida, pasarela de pagos"/>
</div>
